import React, { useEffect, useState } from "react";
import { Form, Modal } from "react-bootstrap";
import {
  Cancel,
  DateIcon,
  FileDown,
  SelectUser,
  SingleProfile,
  Users,
} from "../../../styled/AllImages";
import {
  Box,
  ButtonStyled,
  DateInfo,
  FormButtonStyled,
  HeadingStyled,
  LabelStyled,
  LazyImage,
  SpanStyled,
  SubHeadingStyled,
  TextStyled,
  TextWithIcon,
  TimeInfo,
  UserInfo,
} from "../../../styled/Elements";
import { HistoryModalWrapper } from "./styled";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import {
  departmentsList,
  usersTempList,
} from "../../../../helpers/dummyConstants";
import ValidatedInput from "../../../common/inputFields/ValidatedInput";
import { useForm } from "react-hook-form";
import CustomRadioButton from "../../../common/radioButtons/CustomRadio";
import SignupForm from "../../../../pages/auth/signUp/components/SignupForm";
import AddLicenseForm from "../../../../pages/auth/signUp/components/AddLicenseForm";
import AuthApi from "../../../../services/api/authApi";

const AddLicenseModal = ({ show, onHide, title, action, planInfo }) => {
  const { t } = useTranslation();
  const { register } = useForm();

  const handleChange = (e) => {
    const { value } = e.target;

    // setPaymentMethod(parseInt(value));
  };

  return (
    <Modal size="lg" show={show} onHide={onHide} centered>
      <SelectUserModalWrapper>
        <Box className="">
          <Box className="d-flex justify-content-between align-items-center border-bottom mb-4 p-4">
            <HeadingStyled size="24px" weight="bold" color="var(--text)">
              {title}
            </HeadingStyled>
            <Cancel
              className="cursor-pointer"
              style={{ height: "20px", width: "20px" }}
              onClick={onHide}
            />
          </Box>

          <Box className="mb-0 p-4 pb-2 pt-0">
            <AddLicenseForm
              title={title}
              onHide={onHide}
              addLicenseFrm="addLicenseFrm"
              action={action}
              planInfo={planInfo}
            />
          </Box>
        </Box>
      </SelectUserModalWrapper>
      {/* <Box className="modal-footer">
            
                <ButtonStyled
                    label={t("Cancel")}
                    onClick={onHide}
                    bg="var(--bgSecondary)"
                    color="var(--text2)"
                />
            
                <ButtonStyled
                    bg="var(--themeColor)"
                    label={t("Save")}
                />
            </Box> */}
    </Modal>
  );
};

export default AddLicenseModal;

const SelectUserModalWrapper = styled.div`
  .react-datepicker-wrapper {
    input {
      width: 100%;
      color: var(--text);
      font-size: 14px;
      border: none;
      padding-top: 2px;
      cursor: pointer;
      &:focus {
        border: none;
        box-shadow: none;
        outline: none;
      }
    }
  }
  .rangeIconText .mx-2 {
    margin: 0 !important;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0 0px;
    tr {
      td {
        &:first-child {
          max-width: 200px;
          width: 200px;
        }
        border-bottom: 1px solid var(--borderLight);
        padding: 8px 16px;
        color: var(--text);
        font-size: 14px;
        vertical-align: middle;
      }
      &:last-child {
        td {
          border-bottom: 0;
        }
      }
    }
    td {
      border-radius: 0 !important;
    }
  }
`;
